import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';
import { CoreModule } from '@tdwb/core';

import { QuotesModule } from './quotes/quotes.module';
import { TargetedAdModule } from './targeted-ad/targeted-ad.module';
import { LayoutModule } from './layout/layout.module';
import { PageHeaderModule } from './page/header/page-header.module';
import { WebbrokerLearnCommonModule } from './learn/webbroker-learn-common.module';
import { WebbrokerFplCommonModule } from './fpl/webbroker-fpl-common.module';
import { RouterModule } from './router';
import { ChecklistRestService, ChecklistService } from './checklist';

@NgModule({
  imports: [
    AngularCore,
    CoreModule,
    QuotesModule,
    TargetedAdModule,
    LayoutModule,
    PageHeaderModule,
    WebbrokerLearnCommonModule,
    WebbrokerFplCommonModule,
    RouterModule
  ],
  providers: [ChecklistService, ChecklistRestService],
  exports: [
    QuotesModule,
    TargetedAdModule,
    LayoutModule,
    PageHeaderModule,
    WebbrokerLearnCommonModule,
    WebbrokerFplCommonModule
  ]
})
export class WebbrokerCoreModule {
}

export {
  LayoutModule
};

export * from './page/header/page-header.module';
export * from './learn/webbroker-learn-common.module';
export * from './fpl/webbroker-fpl-common.module';
export * from './targeted-ad/targeted-ad.module';
export * from './quotes/quotes.module';
export * from './learn/domain';
export * from './fpl/fpl.domain';
export * from './checklist';
